var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { scrollable: "", width: "720px" },
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title-bar" }, [
            _c(
              "span",
              {
                staticClass: "text-subtitle-1",
                class: { "selected-title": _vm.infoIndex == 0 },
                on: {
                  click: function ($event) {
                    _vm.infoIndex = 0
                  },
                },
              },
              [_vm._v("Modeling")]
            ),
            _c(
              "span",
              {
                staticClass: "text-subtitle-1",
                class: { "selected-title": _vm.infoIndex == 1 },
                on: {
                  click: function ($event) {
                    _vm.infoIndex = 1
                  },
                },
              },
              [_vm._v("Posing")]
            ),
            _c(
              "span",
              {
                staticClass: "text-subtitle-1",
                class: { "selected-title": _vm.infoIndex == 2 },
                on: {
                  click: function ($event) {
                    _vm.infoIndex = 2
                  },
                },
              },
              [_vm._v("Use & Tips")]
            ),
          ]),
          _vm.infoIndex == 0
            ? _c("InfoGenerate", {
                on: {
                  "show-info-pose": function ($event) {
                    _vm.infoIndex = 1
                  },
                  "show-info-tips": function ($event) {
                    _vm.infoIndex = 2
                  },
                },
              })
            : _vm._e(),
          _vm.infoIndex == 1
            ? _c("InfoPose", {
                on: {
                  "show-info-generate": function ($event) {
                    _vm.infoIndex = 0
                  },
                  "show-info-tips": function ($event) {
                    _vm.infoIndex = 2
                  },
                },
              })
            : _vm._e(),
          _vm.infoIndex == 2
            ? _c("InfoEditorTips", {
                attrs: { showCameraNavigateMode: _vm.isTouchMode },
                on: {
                  "show-info-generate": function ($event) {
                    _vm.infoIndex = 0
                  },
                  "show-info-pose": function ($event) {
                    _vm.infoIndex = 1
                  },
                },
              })
            : _vm._e(),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "accent" }, on: { click: _vm.closeDialog } },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }